/* eslint react-hooks/exhaustive-deps: 0 */

import React, {
  useState,
  useEffect,
  forwardRef,
  useRef,
  useImperativeHandle,
} from 'react';
import scrollIntoView from 'scroll-into-view';

import * as S from './styled';

const TwoOptionsButton = (
  {
    options,
    value,
    onClick,
    invalid,
    errorMessage,
    validations = [],
    ...other
  },
  ref
) => {
  const buttonRef = useRef(null);
  const [objectOptions, setObjectOptions] = useState(['', '']);
  useEffect(() => {
    if (options) {
      setObjectOptions(
        options.map(option => ({
          value: option.value || option,
          label: option.label || option,
        }))
      );
    }
  }, [options]);

  const validate = () => {
    const invalidRule = validations.find(v =>
      v.validate(objectOptions.some(opt => opt.value === value) ? value : '')
    );
    const validationState = invalidRule
      ? {
          invalid: true,
          errorMessage: invalidRule.errorMessage,
        }
      : {
          invalid: false,
          errorMessage: '',
        };

    if (validationState.invalid) {
      scrollIntoView(buttonRef.current);
    }
    onClick({ ...validationState, value });
    return validationState.invalid;
  };

  useImperativeHandle(
    ref,
    () => ({
      validate,
    }),
    [value, options]
  );

  return (
    <S.TwoOptionButtonContainer ref={buttonRef} data-testid="buttons-container">
      <S.ButtonLeft
        onClick={() =>
          onClick({
            invalid: false,
            errorMessage: '',
            value: objectOptions[0].value,
          })
        }
        selected={value === objectOptions[0].value}
        {...other}
        invalid={invalid}
        data-testid="left-button"
      >
        {objectOptions[0].label}
      </S.ButtonLeft>
      <S.ButtonRight
        onClick={() =>
          onClick({
            invalid: false,
            errorMessage: '',
            value: objectOptions[1].value,
          })
        }
        selected={value === objectOptions[1].value}
        {...other}
        invalid={invalid}
        data-testid="right-button"
      >
        {objectOptions[1].label}
      </S.ButtonRight>
    </S.TwoOptionButtonContainer>
  );
};

export default forwardRef(TwoOptionsButton);
